module.exports = __webpack_public_path__ + "img/l1.8420d703.png";